// src/tracking/gtm/config/gtm-config.ts
import { GTMConfig, PageSelectors } from './types';

// Core event types with GA4 and FB mappings
export const EVENT_TYPES = {
  VIDEO: {
    START: 'VIDEO_START',
    PROGRESS: 'VIDEO_PROGRESS',
    MILESTONE: 'VIDEO_MILESTONE',
    COMPLETE: 'VIDEO_COMPLETE'
  },
  SURVEY: {
    START: 'SURVEY_START',
    PROGRESS: 'SURVEY_PROGRESS',
    ANSWER: 'SURVEY_QUESTION_ANSWER',
    QUALIFY: 'SURVEY_QUALIFICATION_STATUS',
    COMPLETE: 'SURVEY_COMPLETE'
  },
  CONVERSION: {
    APPOINTMENT: 'APPOINTMENT_BOOKED', // Primary funnel goal
    DOWNLOAD: 'DOWNLOAD_CONTENT',      // LTV Tracker download
    JOIN: 'JOIN_COMMUNITY'            // Skool Group join
  }
};

// Standard parameter sets for different event types
export const EVENT_PARAMS = {
  BASE: {
    content_type: '',
    page_type: 'vsl',
    funnel_path: '',
    event_id: '',
    timestamp: ''
  },
  VIDEO: {
    video_id: '',
    video_title: '',
    video_duration: 0,
    video_percent: 0,
    video_status: ''
  },
  SURVEY: {
    survey_id: '',
    survey_step: 0,
    survey_answer: '',
    survey_version: ''
  },
  APPOINTMENT: {
    appointment_id: '',
    ghl_id: '',
    appointment_timezone: '',
    appointment_start_date: '',
    appointment_start_time: ''
  }
};

export const GTM_CONFIG: GTMConfig = {
  debug: import.meta.env.VITE_DEBUG === 'true',
  ga4Id: import.meta.env.VITE_GA4_ID || '',
  environment: import.meta.env.VITE_ENVIRONMENT || 'development',
  gtmContainerId: import.meta.env.VITE_GTM_CONTAINER_ID || '',
  supabaseUrl: import.meta.env.VITE_SUPABASE_URL || ''
};

export const PAGE_SELECTORS: PageSelectors = {
  video: ['video', '[data-content-type="video"]', '#video-player'],
  survey: ['[data-content-type="survey"]', '#survey-container'],
  conversion: ['[data-content-type="conversion"]', '#thank-you', '#success']
};
